var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "request-bank-statements-container" },
    [
      _c(
        "fixed-banner",
        {
          attrs: {
            icon: false,
            type: "notice",
            "position-fixed": false,
            "side-right": false,
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("bank-statements.messages.issuesConnectingEQBank")
              ) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row no-gutters mt-2 align-items-center mb-4" },
        [
          _c("div", { staticClass: "col-12" }, [
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "request-package.requestBankStatements.byDefaultWeWillAttemptToPull"
                    )
                  ) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "material-input",
                {
                  staticClass: "form-group-material-no-label",
                  attrs: { value: _vm.computedBankMonths },
                },
                [
                  _c("radio-section", {
                    attrs: {
                      name: "time-worth-of-statements",
                      options: _vm.timeWorthOptions,
                    },
                    model: {
                      value: _vm.computedBankMonths,
                      callback: function ($$v) {
                        _vm.computedBankMonths = $$v
                      },
                      expression: "computedBankMonths",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row no-gutters my-2 align-items-center" }, [
        _c("h6", { staticClass: "bold" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t(
                  "request-package.requestBankStatements.additionalApplicantsBankStatements"
                )
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t(
                  "request-package.requestBankStatements.additionalApplicantsSubtitle"
                )
              ) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { attrs: { "no-gutters": "" } },
        [
          _c("b-col", { attrs: { cols: "10", md: "6" } }, [
            _c("p", { staticClass: "bold mb-4" }, [
              _vm._v("\n        " + _vm._s(_vm.mainApplicantName) + "\n      "),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n        " + _vm._s(_vm.clientEmail) + "\n      "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "10", md: "6" } },
            [
              _c("p", { staticClass: "bold mb-0" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$tc(
                        "global.doorr.coapplicant",
                        _vm.applicants.length - 1
                      )
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "material-input",
                [
                  _c("applicant-select", {
                    attrs: {
                      id: "applicant-select-emails",
                      value: _vm.bankStatementsRequests.emails,
                      "applicants-to-exclude": [{ applicantIndex: 0 }],
                      "only-applicants-with-email": "",
                    },
                    on: { change: _vm.handleChangeEmails },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }